<template>
  <div class="home">
    <app-header></app-header>

    <!-- 轮播Banner -->
    <!-- 第一屏：轮播图 -->
    <!-- 轮播外层 -->
    <div class="swiper-box">
      <!-- 轮播外层 -->
      <swiper ref="mySwiper" :options="swiperOptions">
        <!-- 轮播项 -->
        <swiper-slide v-for="(slide, index) in carouselSlides" :key="index">
          <img :src="slide.bgImage" alt="" />
          <div class="slide-content">
            <div class="container">
              <div class="slide-text-box">
                <h1 class="slide-title">{{ slide.title }}</h1>
                <div class="title-divider"></div>
                <p class="slide-subtitle">{{ slide.subtitle }}</p>
                <div class="slide-icon">
                  <span>↓</span>
                </div>
                <div class="slide-btns">
                  <a href="#" class="btn btn-primary">{{ slide.buttonText }}</a>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>

        <!-- 小圆点 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- 六大难题 -->
    <ProblemsSection />

    <!-- 平台价值 -->
    <section class="values">
      <h2>康道道——让医药渠道更有序、更高效、更合规</h2>
      <div class="values-grid">
        <div class="value-card">
          <img class="icon" src="@/assets/home/value-card01.png" />
          <h3>渠道一盘货管理</h3>
          <p>全国布局统一可视，区域清晰、权限明确</p>
        </div>
        <div class="value-card">
          <img class="icon" src="@/assets/home/value-card02.png" />
          <h3>终端全量覆盖</h3>
          <p>药店、诊所、民营医院一网打尽</p>
        </div>
        <div class="value-card">
          <img class="icon" src="@/assets/home/value-card03.png" />
          <h3>团队高效运营</h3>
          <p>团队长、业务员分级管理、自动考核</p>
        </div>
        <div class="value-card">
          <img class="icon" src="@/assets/home/value-card04.png" />
          <h3>动销数据实时化</h3>
          <p>业绩、网点、覆盖实时呈现</p>
        </div>
        <div class="value-card">
          <img class="icon" src="@/assets/home/value-card05.png" />
          <h3>防串货防乱价</h3>
          <p>锁定关系唯一、流向可追溯</p>
        </div>
        <div class="value-card">
          <img class="icon" src="@/assets/home/value-card06.png" />
          <h3>合规有序营销</h3>
          <p>构建长期、健康、可持续的渠道生态</p>
        </div>
      </div>
    </section>

    <!-- 四端联动 -->
    <section class="ends">
      <h2>一套系统·四端联动·全链路覆盖</h2>
      <div class="ends-grid">
        <div class="end-card">
          <h3>团队长端（小程序）</h3>
          <p>团队管理、业绩考核、区域拓展</p>
        </div>
        <div class="end-card">
          <h3>业务员端（小程序）</h3>
          <p>药店拜访、品种推广、客户维护</p>
        </div>
        <div class="end-card">
          <h3>药店端（小程序）</h3>
          <p>合作确认、产品接收、动销协同</p>
        </div>
        <div class="end-card">
          <h3>PC管理后台</h3>
          <p>数据大屏、全局布局、运营管控<br />权限管理</p>
        </div>
      </div>
    </section>

    <!-- 数据可视化 -->
    <section class="dashboard">
      <h2 class="bigTitle">一张图看懂全国渠道布局</h2>
      <h3 class="smallTitle">数据驱动决策，让渠道管理一目了然。</h3>
      <div class="dashboard-img">
        <img src="@/assets/home/layout-dashboard.png" alt="数据大屏" />
      </div>
    </section>

    <!-- 核心解决方案 -->
    <section class="solutions">
      <h2 class="bigTitle">核心解决方案</h2>
      <h3 class="smallTitle">为医药企业提供一站式广阔市场精细化运营服务</h3>
      <div class="solutions-grid">
        <div class="solution-card">
          <img class="icon icon1" src="@/assets/home/solution01.png" />
          <h3>医药企业渠道数字化搭建</h3>
        </div>
        <div class="solution-card">
          <img class="icon icon2" src="@/assets/home/solution02.png" />
          <h3>终端网点开发与标准化管理</h3>
        </div>
        <div class="solution-card">
          <img class="icon icon3" src="@/assets/home/solution03.png" />
          <h3>营销团队体系化建设与考核</h3>
        </div>
        <div class="solution-card">
          <img class="icon icon4" src="@/assets/home/solution04.png" />
          <h3>有序营销与防串货管控方案</h3>
        </div>
        <div class="solution-card">
          <img class="icon icon5" src="@/assets/home/solution05.png" />
          <h3>数据化动销提升与业绩增长服务</h3>
        </div>
      </div>
    </section>

    <!-- 合作客户 -->
    <section class="clients">
      <h2 class="bigTitle">合作客户</h2>
      <h3 class="smallTitle">已助力多家医药企业实现渠道数字化升级</h3>
      <div class="clients-grid">
        <div class="client-logo" v-for="(item, index) in clients" :key="index">
          <img :src="item" alt="客户logo" />
        </div>
      </div>
    </section>

    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import ProblemsSection from './components/ProblemsSection.vue'

export default {
  name: 'HomePage',
  components: {
    AppHeader,
    AppFooter,
    ProblemsSection,
  },
  data() {
    return {
      swiperOptions: {
        // 👇 最常用配置（直接用）
        loop: true, // 无限循环
        autoplay: {
          delay: 3000, // 3秒切换一次
          disableOnInteraction: false, // 滑动后不停止自动轮播
          pauseOnMouseEnter: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true, // 小圆点可点击
        },
        speed: 600, // 切换速度
        slidesPerView: 1, // 一屏显示几张
        spaceBetween: 0, // 图片间距
        effect: 'slide',
      },
      clients: [
        require('@/assets/home/image_20_02.gif'),
        require('@/assets/home/image_20_04.gif'),
        require('@/assets/home/image_20_06.gif'),
        require('@/assets/home/image_20_08.gif'),
        require('@/assets/home/image_20_10.gif'),
        require('@/assets/home/image_20_16.gif'),
        require('@/assets/home/image_20_17.gif'),
        require('@/assets/home/image_20_18.gif'),
        require('@/assets/home/image_20_19.gif'),
        require('@/assets/home/image_20_20.gif'),
        require('@/assets/home/image_20_16.gif'),
        require('@/assets/home/image_20_17.gif'),
        require('@/assets/home/image_20_18.gif'),
        require('@/assets/home/image_20_19.gif'),
        require('@/assets/home/image_20_20.gif'),
      ],
      currentSlide: 0,
      carouselSlides: [
        {
          bgImage: require('@/assets/home/banner01.png'),
          title: '医药广阔市场\n数字化精细化管理专家',
          subtitle: '解决渠道小、散、乱、管控弱、串货风险\n构建合规、有序、可追溯的全链路医药营销体系',
          buttonText: '立即体验演示',
        },
        {
          bgImage: require('@/assets/home/banner01.png'),
          title: '全渠道数字化管理\n赋能医药企业',
          subtitle: '一站式解决方案，助力企业数字化转型\n提升渠道效率，降低运营成本',
          buttonText: '了解更多',
        },
        {
          bgImage: require('@/assets/home/banner01.png'),
          title: '数据驱动决策\n智能运营管理',
          subtitle: '实时数据监控，精准营销分析\n让管理更简单，让决策更科学',
          buttonText: '立即咨询',
        },
      ],
      autoPlayTimer: null,
    }
  },
  computed: {
    trackStyle() {
      return {
        transform: `translateX(-${this.currentSlide * 100}%)`,
      }
    },
  },
  mounted() {
    this.startAutoPlay()
    window.document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.startAutoPlay()
      } else {
        this.stopAutoPlay()
      }
    })
  },
  beforeDestroy() {
    this.stopAutoPlay()
    window.document.removeEventListener('visibilitychange', () => {})
  },
  methods: {
    nextSlide() {
      if (this.currentSlide < this.carouselSlides.length - 1) {
        this.currentSlide++
      } else {
        this.currentSlide = 0
      }
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--
      } else {
        this.currentSlide = this.carouselSlides.length - 1
      }
    },
    goToSlide(index) {
      this.currentSlide = index
      this.resetAutoPlay()
    },
    startAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        this.nextSlide()
      }, 3000)
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
        this.autoPlayTimer = null
      }
    },
    resetAutoPlay() {
      this.stopAutoPlay()
      this.startAutoPlay()
    },
  },
}
</script>

<style lang="scss" scoped>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.home {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #ffffff;
  padding-top: 80px;
}

/*轮播图*/
.swiper-box {
  width: 100%;
  height: 800px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.slide-content {
  max-width: 1200px;
  z-index: 2;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-600px, -50%);
  display: flex;
  align-items: center;
}

:deep(.swiper-container) {
  height: 100%;
}
:deep(.swiper-pagination-bullet) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff;
  margin: 0 18px !important;
  opacity: 1 !important;
  &.swiper-pagination-bullet-active {
    border-radius: 5px 5px 5px 5px;
    width: 56px;
  }
}

.slide-text-box {
  background-color: #1ca196b2;
  padding: 40px 46px;
  width: 678px;
  box-sizing: border-box;
  color: #fff;
  margin-top: -80px;
}

.slide-title {
  color: #fff;
  margin-bottom: 25px;
  white-space: pre-line;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  line-height: 53px;
  letter-spacing: 0;
}

.title-divider {
  width: 111px;
  height: 2px;
  background-color: #fff;
  margin-bottom: 20px;
}

.slide-subtitle {
  font-size: 24px;
  color: #fff;
  margin-bottom: 22px;
  line-height: 1.8;
  opacity: 0.95;
  white-space: pre-line;

  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  letter-spacing: 0;
}

.slide-icon {
  width: 60px;
  height: 60px;
  border: 2px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 26px;
  cursor: pointer;
  transition: all 0.3s;
}

.slide-icon span {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}

.slide-icon:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(3px);
}

.slide-btns {
  display: flex;
  gap: 20px;
}

.btn-primary {
  width: 180px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 16px;
  background-color: transparent;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
}

.btn-primary:hover {
  background-color: #fff;
  color: #20b8a7;
}

/* 平台价值 */
.values {
  padding: 63px 0 71px;
  background: #f5f5f5;
}
.values h2 {
  text-align: center;
  color: #000000;
  margin-bottom: 64px;

  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  line-height: 100%;
  letter-spacing: 0;
}
.values-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.value-card {
  background: #fff;
  width: 378px;
  height: 240px;
  box-sizing: border-box;
  padding: 43px 0;
  border-radius: 30px;
  text-align: center;
  box-shadow: 0px 4px 10px 0px #1ca19633;
}
.value-card .icon {
  width: auto;
  height: 91px;
  margin-bottom: 12px;
}
.value-card h3 {
  font-size: 20px;
  color: #000000;
  margin-bottom: 8px;
}
.value-card p {
  font-size: 14px;
  color: #000000;
}

/* 四端联动 */
.ends {
  padding: 117px 0 136px;
}
.ends h2 {
  text-align: center;
  color: #333;
  margin-bottom: 64px;

  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  line-height: 100%;
  letter-spacing: 0;
}
.ends-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.end-card {
  background: #009688;
  width: 280px;
  height: 272px;
  box-sizing: border-box;
  color: #fff;
  padding: 92px 0;
  border-radius: 30px;
  text-align: center;
  &::after {
    content: '';
    height: 6px;
    background: #ffffff;
    width: 206px;
    margin: auto;
    display: block;
  }
}
.end-card h3 {
  margin-bottom: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 26px;
  line-height: 100%;
  letter-spacing: 0;
}
.end-card p {
  opacity: 0.9;
  margin-bottom: 64px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0;
}

/* 数据可视化 */
.dashboard {
  padding: 94px 0 82px;
  background: #f5f5f5;
}
.dashboard .bigTitle {
  text-align: center;
  color: #000000;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  line-height: 53px;
  letter-spacing: 0;
}
.dashboard .smallTitle {
  margin-top: 12px;
  margin-bottom: 64px;
  text-align: center;
  color: #000000;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 34px;
  line-height: 45px;
  letter-spacing: 0;
}
.dashboard-img {
  width: 965px;
  height: 546px;
  margin: auto;
  text-align: center;
  border-radius: 8px;
  overflow: hidden;
}
.dashboard-img img {
  width: 100%;
  height: 100%;
}

/* 核心解决方案 */
.solutions {
  padding: 104px 0 0;
}
.solutions .bigTitle {
  text-align: center;
  color: #000000;
  margin-bottom: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  line-height: 53px;
  letter-spacing: 0;
}
.solutions .smallTitle {
  text-align: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 34px;
  line-height: 45px;
  letter-spacing: 0;
  margin-bottom: 106px;
}
.solutions-grid {
  max-width: 1200px;
  margin: 40px auto 0;
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}
.solution-card {
  background: linear-gradient(180deg, #e2f2f0 0%, #ffffff 100%);
  box-shadow: 0px 4px 14.3px 0px #1ca19633;
  padding: 20px;
  border-radius: 20px;
  text-align: center;
  box-sizing: border-box;
  width: 310px;
  height: 126px;
  margin: 0 20px 117px;
}
.solution-card .icon {
  margin: 0 auto;
}
.solution-card .icon1 {
  width: 120px;
  height: auto;
  margin-top: -70px;
}
.solution-card .icon2 {
  width: 90px;
  height: auto;
  margin-top: -70px;
}
.solution-card .icon3 {
  width: 86px;
  height: auto;
  margin-top: -70px;
}
.solution-card .icon4 {
  width: 82px;
  height: auto;
  margin-top: -80px;
}
.solution-card .icon5 {
  width: 64px;
  height: auto;
  margin-top: -70px;
}
.solution-card h3 {
  color: #000000;
  width: 192px;
  margin: auto;
  line-height: 32px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  letter-spacing: 0;
  text-align: center;
  margin-top: 10px;
}

/* 合作客户 */
.clients {
  padding: 108px 0 115px;
  background: #fafafa;
}

.clients .bigTitle {
  text-align: center;
  color: #000000;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  line-height: 53px;
  letter-spacing: 0;
}
.clients .smallTitle {
  margin-top: 12px;
  margin-bottom: 64px;
  text-align: center;
  color: #000000;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 34px;
  line-height: 45px;
  letter-spacing: 0;
}
.clients-grid {
  width: 1047px;
  margin: 40px auto 0;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}
.client-logo {
  background: #fff;
  width: 200px;
  height: 120px;
  border-radius: 4px;
  text-align: center;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.client-logo img {
  width: 100%;
  height: 100%;
}
</style>
